// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module--container--3R8TK","kicker":"index-module--kicker--28ZCN"};